/* ==========================================================================
   EVOGYM — guia de tamanhos
   Insere o link "Size guide" ao lado do seletor de tamanho, SOMENTE em
   vestuário (o tipo do produto vem de ShopifyAnalytics.meta.product.type).
   Equipamentos de academia não recebem.
   ========================================================================== */
(function () {
  'use strict';

  var APPAREL = ['Leggings', 'Top', 'Sports Bra', 'T-Shirt', 'Jacket', 'Bodysuit',
    'Pants', 'Shorts', 'Bermuda Shorts', 'Jumpsuit', 'Romper', 'Set',
    'Tank Top', 'Long Sleeve'];

  var FEMALE = [
    ['XS', '82–85 cm', '61–64 cm', '—'],
    ['S', '87–90 cm', '66–69 cm', '94–97 cm'],
    ['M', '92–95 cm', '70–73 cm', '98–101 cm'],
    ['L', '97–100 cm', '74–77 cm', '102–105 cm'],
    ['XL', '101–104 cm', '78–82 cm', '—']
  ];
  var MALE = [
    ['S', '91–96 cm', '76–81 cm', '93–98 cm'],
    ['M', '97–102 cm', '82–87 cm', '99–104 cm'],
    ['L', '103–108 cm', '88–93 cm', '105–110 cm'],
    ['XL', '109–114 cm', '94–99 cm', '111–116 cm']
  ];

  function table(title, headers, rows) {
    var h = '<h3 class="ev-sg__title">' + title + '</h3>';
    h += '<div class="ev-sg__scroll"><table class="ev-sg__table"><thead><tr>';
    headers.forEach(function (c) { h += '<th>' + c + '</th>'; });
    h += '</tr></thead><tbody>';
    rows.forEach(function (r) {
      h += '<tr><td class="ev-sg__size">' + r[0] + '</td>';
      for (var i = 1; i < r.length; i++) h += '<td>' + r[i] + '</td>';
      h += '</tr>';
    });
    return h + '</tbody></table></div>';
  }

  function buildModal() {
    if (document.getElementById('ev-sizeguide')) return;
    var el = document.createElement('div');
    el.id = 'ev-sizeguide';
    el.className = 'ev-sg';
    el.setAttribute('hidden', '');
    el.innerHTML =
      '<div class="ev-sg__backdrop" data-close></div>' +
      '<div class="ev-sg__panel" role="dialog" aria-modal="true" aria-labelledby="ev-sg-h">' +
        '<button class="ev-sg__close" data-close aria-label="Close">&times;</button>' +
        '<p class="ev-sg__eyebrow">Fit</p>' +
        '<h2 class="ev-sg__heading" id="ev-sg-h">Size guide</h2>' +
        '<p class="ev-sg__note">Measurements are of the body, not the garment. If you are between sizes, take the larger one for a relaxed fit.</p>' +
        table('Women', ['Size', 'Bust', 'Waist', 'Hips'], FEMALE) +
        table('Men', ['Size', 'Chest', 'Waist', 'Hips'], MALE) +
        '<p class="ev-sg__foot">Still unsure? Write to us and we help you pick.</p>' +
      '</div>';
    document.body.appendChild(el);

    el.addEventListener('click', function (e) {
      if (e.target.hasAttribute('data-close')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  function open() {
    buildModal();
    var el = document.getElementById('ev-sizeguide');
    el.removeAttribute('hidden');
    requestAnimationFrame(function () { el.classList.add('is-open'); });
    document.documentElement.style.overflow = 'hidden';
  }
  function close() {
    var el = document.getElementById('ev-sizeguide');
    if (!el) return;
    el.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(function () { el.setAttribute('hidden', ''); }, 250);
  }

  function isApparel() {
    var m = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
    if (!m || !m.type) return false;
    return APPAREL.indexOf(m.type) !== -1;
  }

  function injectLink() {
    if (!isApparel()) return;
    var names = document.querySelectorAll('.product-form__option-name');
    for (var i = 0; i < names.length; i++) {
      var n = names[i];
      if (!/size|tamanho/i.test(n.textContent)) continue;
      if (n.parentElement.querySelector('.ev-sg-link')) continue;
      var a = document.createElement('button');
      a.type = 'button';
      a.className = 'ev-sg-link';
      a.textContent = 'Size guide';
      a.addEventListener('click', open);
      n.parentElement.insertBefore(a, n.nextSibling);
      n.parentElement.classList.add('ev-has-sizeguide');
    }
  }

  function start() {
    injectLink();
    // o tema re-renderiza o bloco ao trocar variante
    var target = document.querySelector('.product-form, .product-block-list') || document.body;
    new MutationObserver(function () { injectLink(); }).observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
